<template>
	<div id="header" onload="" class="cookies_agreement" v-show="is_show">
		<div class="cookies_agreement_text">
			Продолжая, вы подтверждаете использование файлов
			<router-link  :to="{name: 'cookies_agreement'}">
				cookies
			</router-link>
			браузера в целях обеспечения удобного функционирования сайта.
		</div>
		<b-button @click="acceptCookies" class="cookies_agreement_btn">
			ПРИНЯТЬ
		</b-button>
	</div>
</template>
<script>
export default {
	name: "CookiesAgreementComponent",
	data() {
		return {
			is_show: true,
		}
	},
	beforeMount() {
		console.log('cookies_agreement:', this.$cookies.get('cookies_agreement'))
		if (this.$cookies.get('cookies_agreement') === 'true') {
			this.is_show = false
		}
	},
	methods: {
		acceptCookies() {
			this.is_show = false
			this.$cookies.set('cookies_agreement', 'true', '1m')
		},
	},
}
</script>
<style scoped>
.cookies_agreement {
	background-color: white;
    color: black;
    position: fixed;
	width: calc(100% - 2em);
    max-width: 480px;
    height: auto;
    bottom: 1em;
    right: 1em;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 1em;
    border-radius: 1em;
    font-size: 0.9em;
	z-index: 999999;
	box-shadow: 0px 0px 15px #000000;
}
.cookies_agreement_btn {
	color: black;
	background-color: #A6CBD3;
	height: 2em;
}
</style>